import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

// Import stylesheets
import './styles/imageResponsive.css';
import './styles/glassmorphism.css';
import './styles/customBackground.css';
import './styles/neonEffects.css';
import './styles/backgrounds.css';
import './styles/glowEffects.css';
import './styles/neonServers.css';
import './styles/logoOptimize.css';
import './styles/customChangelog.css';
import './styles/navbarOptimization.css';
import './styles/mobileOptimization.css'; // Add mobile optimization CSS

import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
